
(function($, document, window) {

	$(function() {
		// jQuery ready!
	});

	const productSingleCollapseItems = $('.bnf-collapse-item > .-header');

	productSingleCollapseItems.click(function() {
		const parent = $(this).parents('.bnf-collapse-item');

		parent.toggleClass('-collapsed');
	});

	const productSingleRelatedCarousel = $('.bnf-products-single--more-products-table > .-items'),
		productSingleRelatedCarouselControls = $('.bnf-products-single--more-products .-carousel-controls');

	productSingleRelatedCarousel.slick({
		slidesToShow: 4,
		infinite: false,
		appendArrows: productSingleRelatedCarouselControls,
		prevArrow: '<button class="bnf-products-single--more-products-control -prev"><svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0.784148H2V12.7841H0V0.784148ZM10.293 0.0771484L3.586 6.78415L10.293 13.4911L11.707 12.0771L7.414 7.78415H16V5.78415H7.414L11.707 1.49115L10.293 0.0771484Z"/></svg></button>',
		nextArrow: '<button class="bnf-products-single--more-products-control -next"><svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14 0.784148H16V12.7841H14V0.784148ZM0 7.78415H8.586L4.293 12.0771L5.707 13.4911L12.414 6.78415L5.707 0.0771484L4.293 1.49115L8.586 5.78415H0V7.78415Z"/> </svg></button>',
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 481,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	const techVideo = $('.bnf-tech--about-app .about-video video')[0],
		techVideoControl = $('#toggle-video-play');

	techVideoControl.click(function() {
		techVideo.play();
		techVideo.controls = true;
		
		$(this).addClass('-hidden');
	});	

	if(techVideo) {
		techVideo.onpause = function() {
			this.controls = false;
	
			techVideoControl.removeClass('-hidden');
		};
	
		techVideo.onended = function() {
			this.controls = false;
			this.load();
	
			techVideoControl.removeClass('-hidden');
		};
	}

	const unitsMap = $('.bnf-units--map .-map'),
		unitsMapStates = unitsMap.find('path');

	if(unitsMap.length > 0) {
		const unitsMapSelected = unitsMap.data('map-selected');
		let unitsMapBaseUrl = unitsMap.data('map-base-url');

		unitsMapStates.click(function() {
			window.location.href = `${unitsMapBaseUrl}?state=${this.id}`;
		});		

		$(`#${unitsMapSelected}`).css('fill', '#333');
	}

	const mobileMenuTrigger = $('#toggle-show-mobile-menu'),
		mobileMenuNav = $('.bnf-navbar-mobile'),
		mobileMenuOverlay = $('.bnf-mobile-overlay');

	mobileMenuTrigger.click(function() {
		$(this).toggleClass('-close');
		mobileMenuNav.toggleClass('-enabled');
		mobileMenuOverlay.toggleClass('-enabled');
		$('body').toggleClass('overflow-hidden');
	});

	mobileMenuOverlay.click(function() {
		$(this).removeClass('-enabled');
		mobileMenuTrigger.removeClass('-close');
		mobileMenuNav.removeClass('-enabled');
		$('body').removeClass('overflow-hidden');
	});

	const topHeader = $('.bnf-header-top');

	$(window).scroll(function() {
		const scrollPosition = $(this).scrollTop();

		if(scrollPosition > 80) {
			topHeader.addClass('-scrolled');
		} else {
			topHeader.removeClass('-scrolled');
		}
	});

	const mobileSubmenuTrigger = $('.-has-submenu > i');

	mobileSubmenuTrigger.click(function() {
		const parent = $(this).parents('li');

		parent.toggleClass('-submenu-enabled');
	});

	const aAnchor = $('a');

	aAnchor.click(function(event) {
		const hash = this.hash;

		if(hash) {
			const target = $(`${hash}`);

			if(target.length > 0) {
				event.preventDefault();
				
				const offset = target.offset().top;

				$('html, body').animate({
					scrollTop: offset
				}, 800);
			}
		}
	});

	const forms = $('form');

	forms.submit(function(event) {
		const inputs = $(this).find('.bnf-form-control:not(.-norq)');

		inputs.each((index, el) => {
			const $el = $(el);

			if(!$el.val() || $el.val() === '') {
				event.preventDefault();

				$el.addClass('-wrong');
			} else {
				$el.removeClass('-wrong');
			}
		});
	});

	const UrlHandler = {
		url: window.location.href,
		base: null,
		params: null,
		init: function() {
			const regExpHasParams = new RegExp('[\?]', 'g');

			if(regExpHasParams.test(this.url)) {
				this.params = {};

				const [url, params] = this.url.split('?'),
					paramsArray = params.split('&');

				this.base = url;

				for(let param in paramsArray) {
					const [name, value] = paramsArray[param].split('=');

					this.params[name] = value;
				}
			} else {
				this.base = this.url;
			}
		}
	};

	UrlHandler.init();

	if(UrlHandler.params && UrlHandler.params.hasOwnProperty('scrollto')) {
		const target = $(`#${UrlHandler.params.scrollto}`);

		if(target.length > 0) {			
			const offset = target.offset().top;

			$('html, body').animate({
				scrollTop: offset
			}, 800);
		}
	}

	const productsFiltering = $('.bnf-products-page--filtering input[type="checkbox"]');

	productsFiltering.change(function() {
		const form = $(this).parents('form'),
			hidden = $(this).parents('.-accordion-filter--content').find('input[type="hidden"]'),
			hiddens = $('.-accordion-filter--content input[type="hidden"]');

		if(hidden.val() !== '') {
			const value = hidden.val().split('.');

			if($(this).prop('checked')) {
				value.push($(this).val());
			} else {
				value.splice(value.indexOf($(this).val()), 1);
			}

			hidden.val(value.join('.'));
		} else {
			hidden.val($(this).val());
		}

		hiddens.each(function(i, el) {
			if(el.value === '') {
				el.disabled = true;
			}
		});

		form.submit();
	});

	const productsSorting = $('.bnf-products-page-sorting > select');

	productsSorting.change(function() {
		window.location.href = $(this).val();
	});

	const colorsDropdown = $('.colors-dropdown'),
		colorsDropdownOptions = $('.colors-dropdown > .colors-options > li'),
		colorSelected = $('.colors-dropdown > .color-selected'),
		colorSelectedDefault = colorSelected.html(),
		productsCarousel = $('.bnf-products-single--carousel .slider-vert-nav');

	if(colorsDropdown.length > 0) {
		colorsDropdown.click(function(event) {
			event.stopPropagation();

			$(this).toggleClass('-dropped');
		});

		$('body').click(function() {
			colorsDropdown.removeClass('-dropped');
		});
	
		colorsDropdownOptions.click(function(event) {
			event.stopPropagation();

			const color = $(this).data('color'),
				index = productsCarousel.find('figure').index(productsCarousel.find(`figure[data-color="${color}"]`));
	
			if(!(index < 0)) {
				productsCarousel.find('figure').eq(index).click();
			} 
	
			colorSelected.html($(this).html());
			colorsDropdown.removeClass('-dropped');
		});

		productsCarousel.on('afterChange', function() {
			colorSelected.html(colorSelectedDefault);
		});
	}

	const wpcf7SelectOption2Optgroup = $('[name="free-trial-units"] option:contains("optgroup-")');

	if(wpcf7SelectOption2Optgroup.length > 0) {
		wpcf7SelectOption2Optgroup.each(function(i, el) {
			const updated = $(el).val().replace('optgroup-', '');

			$(el).nextUntil('option:contains("endoptgroup")').wrapAll(`<optgroup label="${updated}"></optgroup>`)
		});

		$('[name="free-trial-units"] option:contains("optgroup-")').remove();
		$('[name="free-trial-units"] option:contains("endoptgroup")').remove();
	}

}(window.jQuery, document, window));